export const EMAIL_SEND_DELAY = 3000;

export const EVM_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/g;
